<template>
  <div class="w-100 h-100 d-fx fxd-c ai-c pl-38px pr-38px">
    <h2 class="f-27px fw-b lh-33px c-we mt-90px">Create Account</h2>
    <p class="c-we_80 f-12px lh-18px fw-400 t-c mt-18px">When you join {{this.siteData}}, you can use all services of {{this.siteData}}. Become {{this.siteData}} that changes the world with your ideas.</p>
    <button ripple="ripple" class="w-201px h-60px bo-1px bor-100px mt-30px bo-we cursor-pointer o-h" @click="updateParentSwap()">
      <span class="f-18px lh-60px c-we t-c b-bk_10-h">SIGN UP</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'InQuestionC',
  extends: {},
  props: {
    siteData: String
  },
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {
    updateParentSwap() {
      this.$parent.swap = !this.$parent.swap
    }
  },
  beforeCreate(){},
  mounted(){}
}
</script>
